module.exports = __webpack_public_path__ + "static/media/uploadDarkMode.c19738f2.svg";